import curry from 'lodash.curry';
import createAction from './createAction';

export default (function (type, payloadCreator) {
  return curry(createAction(type, payloadCreator), payloadCreator.length);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/createCurriedAction.js
// module id = 1780
// module chunks = 0